import React from "react";
import PropTypes from 'prop-types'
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import DesignMode from "./DesignMode/DesignMode";
import PlayerMode from "./PlayerMode/PlayerMode";


const Survey = ({surveyComponent}) => {
    const {properties: {type, dataSource, sourceId, showScoring} = {}, styles} = surveyComponent;
    return (
        type === 'design' ? (
            <DesignMode
                dataSource={dataSource}
            />
        ) : (
            <PlayerMode
                dataSource={dataSource}
                styles={styles}
                surveyId={sourceId}
                showScoring={showScoring}
            />
        )
    )
};

export default JsonScreenHoc(Survey);

Survey.propTypes = {
    surveyId: PropTypes.string,
    fieldName: PropTypes.string
};